import React from 'react';

import type { IconProps } from '../../icon-types';
import { IconBase } from '../../IconBase';

export const LpaIcon = React.forwardRef<SVGSVGElement, IconProps>(function LpaIcon(props, ref) {
    return (
        <IconBase
            ref={ref}
            viewBox="0 0 17 18"
            {...props}
        >
            <path
                fill="currentColor"
                d="m3.67 14.55-.27 1.87c-.19 1.22-.93 1.64-1.64 1.57S.37 17.35.6 15.93l.63-3.77s2 2.15 2.16 2.25.28.14.28.14m5.89-4.93c.91 1.84 1.66 3.33 1.99 3.96.5.97.13 1.63-.47 1.95s-1.42.32-1.93-.64c-.24-.45-.87-1.75-1.57-3.23zM6.07 8.45 4.88 5.91l-.58 4.24v.03l-.14.1L2.2 8.23s-.04-.1-.27-.2L3.13.98c.1-.57.26-.8.65-.94.44-.14.9.08 1.17.57.94 1.75 2.08 3.98 3.16 6.1z"
            />
            <path
                fill="currentColor"
                d="M.3 8.72a1 1 0 0 1 1.25-.12 35 35 0 0 1 2.61 2.87c2.3-2.83 9.12-8.1 11.36-9.3a.55.55 0 0 1 .74.2c.1.2.08.55-.17.7C12.63 5.01 6.3 11.9 4.91 13.62c-.47.58-1.3.23-1.52-.11a42 42 0 0 0-3.12-3.44.95.95 0 0 1 .04-1.36M12.55 15h-.13v-.1h.38v.1h-.14v.46h-.11zm.36-.1h.12l.13.42.13-.42h.12l.07.56h-.11l-.03-.25v-.1l-.03.1-.03.12q-.02.09-.12.1-.1-.01-.11-.1l-.04-.12-.02-.1v.1l-.03.25h-.12z"
            />
        </IconBase>
    );
});
